import jwt_decode from "jwt-decode";

export const isTokenValid = () => {
  const token = localStorage.getItem("TOKEN");
  if (!token) return false;

  try {
    const decoded = jwt_decode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return false;
  }
};

export const isRefreshTokenValid = () => {
  const refreshToken = localStorage.getItem("REFRESH_TOKEN");
  if (!refreshToken) return false;

  try {
    const decoded = jwt_decode(refreshToken);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    console.error("Error decoding refresh token:", error);
    return false;
  }
};

export const clearAuthTokens = () => {
  localStorage.removeItem("TOKEN");
  localStorage.removeItem("REFRESH_TOKEN");
};

export const getDecodedToken = () => {
  const token = localStorage.getItem("TOKEN");
  if (!token) return null;

  try {
    return jwt_decode(token);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const shouldRedirectToLogin = () => {
  const token = localStorage.getItem("TOKEN");
  if (!token) return true;

  return !isTokenValid();
};
